exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".InviteButton-aa992518{display:inline-block}\n", ""]);

// Exports
exports.locals = {
	"InviteButton": "InviteButton-aa992518"
};